import 'css-chunksrc/client/scenes/organizationalUnitMove/organizationalUnitSelection/styles.scss';export default {
  "input": "_input_xqgtd_1",
  "placeholder": "_placeholder_xqgtd_15",
  "icon": "_icon_xqgtd_22",
  "listRoot": "_listRoot_xqgtd_28",
  "list": "_list_xqgtd_28",
  "opened": "_opened_xqgtd_42",
  "name": "_name_xqgtd_51",
  "selected": "_selected_xqgtd_61"
};